module.exports = __webpack_public_path__ + "img/credits_mobile.e38a9896.png";